import { defineStore } from "pinia";
import { useLK } from "@/controllerLK/LKstore";
import axios from "axios";
import { useNotificationsStore } from "@/store/notifications";
import { t } from "@/controllerLK/AvalLocalization";
import Crud from "@/store/NewsFeed/crud";
import { useRubricsStore } from "@/store/NewsFeed/rubrics";
import {convertIdsToString} from "@/functions/basic";
import { projectsApi } from "@/composables/api/projects.api";

const crud = new Crud(
    "",
    "id",
    "",
    {}
);

export const useThemesStore = defineStore({
  id: "themes",
  state: () => ({
    ...crud.state,
    allThemes: [],
    chosenThemes: [],
    pulseCards: []
  }),
  getters: {
    ...crud.getters,
  },
  actions: {
    ...crud.actions,
    // Список всех рубрик в теме.
    allRubricsInThemes () {
      if (this.chosenThemes.length > 0) {
        let allRubricsInThemes = [];
        this.allThemes.forEach((theme) => {
          if (this.chosenThemes.includes(theme.id)) {
            allRubricsInThemes.push(...theme.rubric_ids);
          }
        });
        allRubricsInThemes = [...new Set(allRubricsInThemes)];
        return allRubricsInThemes;
      }
      return [];
    },
    // Получение всех тем по проекту
    async getAllThemes() {
      const LKStore = useLK();
      try {
        const raw = await projectsApi.listThemes(LKStore.project.id);

        // TODO: Удалить функцию и все места где используется, после изменения айдишников на беке. task 1873.
        const data = convertIdsToString(raw);
        for (const theme of data) {
          theme.rubric_ids = theme.rubric_ids.map((item) => item.toString());
        }
        //

        this.allThemes = data;
        return data;
      } catch (err) {
        this.setError(err);
      }
    },
    // Изменение порядка темы. (Вверх/Вниз)
    // TODO: endpoint /blocks/{id}/move отсутствует в новом swagger (api_swagger/projects.json).
    // Фича перестановки тем сейчас не работает — нужен новый endpoint или отказ от UI.
    async changeThemeNumber(id, boolean) {
      const LKStore = useLK();
      const url = process.env.VUE_APP_BASE_API + `projects/${LKStore.project.id}/blocks/${id}/move?is_up=${boolean}`;

      try {
        await axios.put(url);
      } catch (error) {
        this.setError(error);
      }
    },
    // Получение всех тем по проекту для пульса, с карточками.
    // TODO: endpoint /blocks/pulse/cards отсутствует в новом swagger.
    // Pulse-карточки сейчас не загрузятся — endpoint не мигрировал.
    async getAllThemesPulse() {
      const LKstore = useLK();
      const url = process.env.VUE_APP_BASE_API + `projects/${LKstore.project.id}/blocks/pulse/cards`;
      this.startLoading();

      try {

        const response = await axios.get(url);

        // TODO: Удалить функцию и все места где используется, после изменения айдишников на беке. task 1873.
        const data = convertIdsToString(response.data);
        for (const theme of data) {
          theme.rubric_ids = theme.rubric_ids.map((item) => item.toString());
        }
        //


        this.pulseCards = data;
        return data;
      } catch (err) {
        this.setError(err);
      }
    },
    // Создание новой темы проекта
    async addNewTheme(theme) {
      const LKStore = useLK();
      const notificationStore = useNotificationsStore();

      try {
        await projectsApi.createTheme(LKStore.project.id, theme);
        await this.getAllThemes();
        notificationStore.createNotify(t("news_page_themes_edit_popup.toast.create", theme.name), "success");
      } catch (err) {
        this.setError(err);
      }
    },
    // Удаление темы проекта по идентификатору
    async deleteTheme(themeId, themeName = "") {
      const LKStore = useLK();
      const notificationStore = useNotificationsStore();

      try {
        await projectsApi.removeTheme(LKStore.project.id, themeId);
        await this.getAllThemes();
        notificationStore.createNotify(t("news_page_themes_edit_popup.toast.delete", themeName), "success");
      } catch (err) {
        this.setError(err);
      }
    },
    // Обновление темы
    async updateTheme(theme) {
      const rubricStore = useRubricsStore();
      const LKStore = useLK();
      const notificationStore = useNotificationsStore();

      try {
        await projectsApi.updateTheme(LKStore.project.id, theme.id, theme);
        notificationStore.createNotify(t("news_page_themes_edit_popup.toast.save", theme.name), "success");
        if (this.chosenThemes.length === 1 && theme.id === this.chosenThemes[0]) {
          rubricStore.chosenRubrics = theme.rubric_ids;
        }
      } catch (err) {
        this.setError(err);
      }
    },
  },
});
